import React, { ReactNode } from 'react';
import { ButtonTheme, GenericPopup } from '@apply/components';

export interface ConfirmV2Props {
    id: string;
    children: ReactNode;
    title?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    okLabel?: string;
    cancelLabel?: string;
    open: boolean;
    height?: string;
    width?: string;
}

export const ConfirmV2: React.FC<ConfirmV2Props> = ({
    id,
    children,
    title = 'Confirm Action',
    okLabel = 'OK',
    cancelLabel = 'Cancel',
    open = true,
    onCancel,
    onConfirm,
    height = 'auto',
    width = 'auto',
}) => {
    const actionButtons = [
        {
            id: `${id}_confirmButton`,
            theme: ButtonTheme.Primary,
            disabled: false,
            children: okLabel,
            width: '150px',
            handleClick: onConfirm,
        },
        {
            id: `${id}_cancelButton`,
            theme: ButtonTheme.Decline,
            children: cancelLabel,
            width: '150px',
            handleClick: onCancel,
        },
    ];

    return (
        <GenericPopup
            id={id}
            isOpen={open}
            actionButtons={actionButtons}
            handleClose={onCancel}
            aria-labelledby='alert-dialog-title'
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={title}
            width={width}
            height={height}
            maxWidth='90%'
            maxHeight='70%'
            buttonAlignment='center'
            wrapTitle={true}
        >
            <div>{children}</div>
        </GenericPopup>
    );
};
